import React from 'react'
import MainLayout from '../components/MainLayout'
import ServicesCards from '../components/servicesCards/ServicesCards';
import ContactFormServices from '../components/contactFormServices/ContactFormServices';

const ServicesPage = () => {
    return (
        <MainLayout>
            <ServicesCards />
            <ContactFormServices />
        </MainLayout>
    )
}

export default ServicesPage